import React from 'react';
import '../App.css';

function ConfidenceBadge({ confidence }) {
  return (
    <span className={`confidence-badge confidence-${confidence}`}>
      {confidence.toUpperCase()}
    </span>
  );
}

export default ConfidenceBadge;
